export default "__VITE_ASSET__CYiuwUbZ__"